import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@codex/themes';
import { wasPriceDateTrimYear } from '@codex/helpers';
import ProductList from './components/ProductList.jsx';
import ProductGrid from './components/ProductGrid.jsx';
import browserHistory from '../../../appState/browserHistory';
import { getCurrentFiltersSetup, getCurrentUCMS } from './helpers';
import translations from './translations';
import ProductPriceBlockWrapper,
{ VARIANT_FO_SITE_LISTING_PAGE_GRID, VARIANT_FO_SITE_LISTING_PAGE_LIST }
  from '../ProductPriceBlock/ProductPriceBlockWrapper.jsx';

const VIEW_TYPE_GRID = 'grid';

export default function initProductListing() {
  const mountEl = document.querySelector('[data-component="product-list-view"]');
  if (!mountEl) {
    return;
  }

  // Set current filters state into history list so we can properly load products when
  // navigating back in history to this initial page.
  browserHistory.replaceState({
    type: browserHistory.actionTypes.LISTING_PAGE_FILTERS,
    payload: getCurrentFiltersSetup()
  }, getCurrentUCMS().segment);

  // React product listing is rendered after user clicks on some page in paginator
  // Until clicking on paginator, there are products rendered by server on page because of SEO.
  const unsubscribe = window.appState.subscribe(() => {
    const shouldRender = window.appState.getState().listingPage.pageSetup.renderReactProductList;
    if (shouldRender) {
      const activeView = window.appState.getState().listingPage.pageSetup.viewSwitch;

      if (activeView === VIEW_TYPE_GRID) {
        ReactDOM.render(
          <Provider store={window.appState}>
            <ProductGrid />
          </Provider>,
          mountEl
        );
      } else {
        ReactDOM.render(
          <Provider store={window.appState}>
            <ProductList />
          </Provider>,
          mountEl
        );
      }

      if (unsubscribe) {
        unsubscribe();
      }
    }
  });

  // For initial load, replace price blocks from template with a component
  const products = window.digitalData.products;
  const productsByID = products.reduce((products, product) => {
    // eslint-disable-next-line no-param-reassign
    products[product.productID] = product;
    return products;
  }, {});
  const activeView = window.appState.getState().listingPage.pageSetup.viewSwitch;
  const priceElementClassName = 'amounts';
  const priceElementItems = document.getElementsByClassName(priceElementClassName);

  priceElementItems.forEach((priceElement) => {
    const productId = priceElement.dataset.productid;
    if (productsByID[productId]) {
      ReactDOM.render(
        <ThemeProvider theme={themes.currys}>
          <ProductPriceBlockWrapper
            currentPrice={productsByID[productId].currentPrice}
            savingsPrice={productsByID[productId].savingsPrice}
            wasPrice={productsByID[productId].wasPrice}
            wasPriceFrom={productsByID[productId].wasPriceFrom
              ? wasPriceDateTrimYear(productsByID[productId].wasPriceFrom) : undefined}
            wasPriceTo={productsByID[productId].wasPriceTo
              ? wasPriceDateTrimYear(productsByID[productId].wasPriceTo) : undefined}
            fromDateTranslation={translations.fromDateTranslation}
            toDateTranslation={'-'}
            displayWasPriceRange={!(activeView === VIEW_TYPE_GRID)}
            isOutOfStock={!productsByID[productId].inStock}
            mainProductWasPrice={productsByID[productId].mainProductWasPrice}
            mainProductCurrentPrice={productsByID[productId].mainProductCurrentPrice}
            separateSellingPrice={productsByID[productId].separateSellingPrice}
            mainProductWasPriceTranslation={translations.mainProductWasPriceTranslation}
            mainProductCurrentPriceTranslation={
              translations.mainProductCurrentPriceTranslation
            }
            displayBundlePriceInsidePriceBlock={activeView === VIEW_TYPE_GRID}
            separateSellingPriceTranslation={translations.separateSellingPriceTranslation}
            inStorePrice={productsByID[productId].inStorePrice}
            inStorePriceTranslation={translations.inStorePriceTranslation}
            displayInStorePriceInsidePriceBlock={activeView === VIEW_TYPE_GRID}
            perMonthPrice={productsByID[productId].perMonthPrice}
            perMonthTranslation={translations.perMonthTranslation}
            isFlashSale={productsByID[productId].isFlashSale}
            webExclusivePriceTranslation={translations.webExclusivePriceTranslation}
            variant={
              activeView === VIEW_TYPE_GRID
                ? VARIANT_FO_SITE_LISTING_PAGE_GRID : VARIANT_FO_SITE_LISTING_PAGE_LIST
            }
          />
        </ThemeProvider>,
        priceElement
      );
    } else {
      console.warn('No data in data layer could be found for product ID', productId);
    }
  });
}
